import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@nextui-org/react';
import React from 'react';

import NoData from '@/components/NoData';

import { LOCK_COLUMNS, LOCK_COLUMNS_ID } from './constants';
import LockTokenCell from './HistoryCell';
import useLockedFetch from './useFetch';

const LockTokenHistory: React.FC = () => {
  const { list, loading, handleWhenClaimed, handleWhenWithdraw } = useLockedFetch();

  return (
    <div className="mt-8">
      <Table
        aria-label="History lock table"
        removeWrapper
        isHeaderSticky
        classNames={{
          thead: 'border-none',
          tr: '!shadow-none',
          th: 'sm:text-[13px]',
          td: 'lg:text-[13px] sm:text-[12px]',
          base: 'scrollbar-custom overflow-x-auto overflow-y-auto max-h-[500px]',
        }}
      >
        <TableHeader columns={LOCK_COLUMNS}>
          {(column) => (
            <TableColumn
              aria-hidden={column.id === LOCK_COLUMNS_ID.No}
              aria-checked={column.id === LOCK_COLUMNS_ID.Action}
              aria-expanded={
                column.id === LOCK_COLUMNS_ID.AvailableReward ||
                column.id === LOCK_COLUMNS_ID.EarnedReward
              }
              key={column.id}
              className="bg-gray-50 text-[14px] font-semibold text-gray-700 aria-checked:w-[250px] aria-expanded:text-center sm:aria-hidden:sticky sm:aria-hidden:left-0 sm:aria-hidden:z-[1]"
            >
              {column.title}
            </TableColumn>
          )}
        </TableHeader>
        <TableBody
          items={list}
          isLoading={loading}
          emptyContent={<NoData className="!h-[350px]" />}
        >
          {(item) => (
            <TableRow key={item.id} className="border-b-1 border-[#F0F2FA] last:border-none">
              {(columnKey) => (
                <TableCell
                  aria-hidden={columnKey === LOCK_COLUMNS_ID.No}
                  className="bg-white py-4 sm:py-2 sm:aria-hidden:sticky sm:aria-hidden:left-0 sm:aria-hidden:z-[1]"
                >
                  <LockTokenCell
                    handleWhenClaimed={handleWhenClaimed}
                    data={item}
                    columnKey={columnKey}
                    handleWhenWithdraw={handleWhenWithdraw}
                  />
                </TableCell>
              )}
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default LockTokenHistory;
